import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _LightboxService_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Service, { service } from "@ember/service";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
import { DOCUMENT_ELEMENT_LIGHTBOX_OPEN_CLASS, LIGHTBOX_APP_EVENT_NAMES, MIN_CAROUSEL_ARROW_ITEM_COUNT, MIN_CAROUSEL_ITEM_COUNT, SELECTORS } from "discourse/lib/lightbox/constants";
import { getSiteThemeColor, setSiteThemeColor } from "discourse/lib/lightbox/helpers";
import { processHTML } from "discourse/lib/lightbox/process-html";
import { isDocumentRTL } from "discourse/lib/text-direction";
import { bind } from "discourse-common/utils/decorators";
let LightboxService = disableImplicitInjections(_class = (_class2 = (_LightboxService_brand = /*#__PURE__*/new WeakSet(), class LightboxService extends Service {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _LightboxService_brand);
    _initializerDefineProperty(this, "appEvents", _descriptor, this);
    _initializerDefineProperty(this, "site", _descriptor2, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor3, this);
    _defineProperty(this, "lightboxIsOpen", false);
    _defineProperty(this, "lightboxClickElements", []);
    _defineProperty(this, "lastFocusedElement", null);
    _defineProperty(this, "originalSiteThemeColor", null);
    _defineProperty(this, "onFocus", null);
    _defineProperty(this, "selector", null);
    _defineProperty(this, "callbacks", {});
    _defineProperty(this, "options", {});
  }
  async init() {
    super.init(...arguments);
    this.callbacks = {
      onOpen: this.onLightboxOpened,
      onClose: this.onLightboxClosed,
      onWillChange: this.onLightboxItemWillChange,
      onItemDidChange: this.onLightboxItemDidChange,
      onCleanUp: this.onLightboxCleanedUp
    };
    this.options = {
      isMobile: this.site.mobileView,
      isRTL: isDocumentRTL(),
      minCarouselItemCount: MIN_CAROUSEL_ITEM_COUNT,
      minCarouselArrowItemCount: MIN_CAROUSEL_ARROW_ITEM_COUNT,
      zoomOnOpen: false,
      canDownload: this.currentUser || !this.siteSettings.prevent_anons_from_downloading_files
    };
    this.appEvents.on(LIGHTBOX_APP_EVENT_NAMES.CLEAN, this, this.cleanupLightboxes);
  }
  async onLightboxOpened(_ref) {
    let {
      items,
      currentItem
    } = _ref;
    this.originalSiteThemeColor = await getSiteThemeColor();
    document.documentElement.classList.add(DOCUMENT_ELEMENT_LIGHTBOX_OPEN_CLASS);
    _assertClassBrand(_LightboxService_brand, this, _setupDocumentFocus).call(this);
    this.appEvents.trigger(LIGHTBOX_APP_EVENT_NAMES.OPENED, {
      items,
      currentItem
    });
  }
  async onLightboxItemWillChange(_ref2) {
    let {
      currentItem
    } = _ref2;
    this.appEvents.trigger(LIGHTBOX_APP_EVENT_NAMES.ITEM_WILL_CHANGE, {
      currentItem
    });
  }
  async onLightboxItemDidChange(_ref3) {
    let {
      currentItem
    } = _ref3;
    this.appEvents.trigger(LIGHTBOX_APP_EVENT_NAMES.ITEM_DID_CHANGE, {
      currentItem
    });
  }
  async onLightboxClosed() {
    document.documentElement.classList.remove(DOCUMENT_ELEMENT_LIGHTBOX_OPEN_CLASS);
    setSiteThemeColor(this.originalSiteThemeColor);
    _assertClassBrand(_LightboxService_brand, this, _restoreDocumentFocus).call(this);
    this.originalSiteThemeColor = "";
    this.lightboxIsOpen = false;
    this.appEvents.trigger(LIGHTBOX_APP_EVENT_NAMES.CLOSED);
  }
  onLightboxCleanedUp() {
    return true;
  }
  async openLightbox(_ref4) {
    let {
      container,
      selector,
      clickTarget
    } = _ref4;
    const {
      items,
      startingIndex
    } = await processHTML({
      container,
      selector,
      clickTarget
    });
    if (!items.length) {
      return;
    }
    this.appEvents.trigger(LIGHTBOX_APP_EVENT_NAMES.OPEN, {
      items,
      startingIndex,
      callbacks: {
        ...this.callbacks
      },
      options: {
        ...this.options
      }
    });
    this.lightboxIsOpen = true;
  }
  async closeLightbox() {
    if (this.lightboxIsOpen) {
      this.appEvents.trigger(LIGHTBOX_APP_EVENT_NAMES.CLOSE);
      this.lightboxIsOpen = false;
    }
  }
  async setupLightboxes(_ref5) {
    let {
      container,
      selector
    } = _ref5;
    _assertClassBrand(_LightboxService_brand, this, _setupLightboxes).call(this, {
      container,
      selector
    });
  }
  async cleanupLightboxes() {
    _assertClassBrand(_LightboxService_brand, this, _cleanupLightboxes).call(this);
  }
  handleClickEvent(event, trigger) {
    const closestTrigger = event.target.closest(trigger);
    const isLightboxClick = event.composedPath().find(element => element.matches && (element.matches(trigger) || element.matches("[data-lightbox-trigger]")));
    if (!isLightboxClick) {
      return;
    }
    event.preventDefault();
    this.openLightbox({
      container: event.currentTarget,
      selector: trigger,
      clickTarget: closestTrigger
    });
    event.target.toggleAttribute(SELECTORS.DOCUMENT_LAST_FOCUSED_ELEMENT);
  }
  willDestroy() {
    _assertClassBrand(_LightboxService_brand, this, _reset).call(this);
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "onLightboxOpened", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "onLightboxOpened"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onLightboxItemWillChange", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "onLightboxItemWillChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onLightboxItemDidChange", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "onLightboxItemDidChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onLightboxClosed", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "onLightboxClosed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onLightboxCleanedUp", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "onLightboxCleanedUp"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "openLightbox", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "openLightbox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "closeLightbox", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "closeLightbox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setupLightboxes", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "setupLightboxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cleanupLightboxes", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "cleanupLightboxes"), _class2.prototype)), _class2)) || _class;
async function _setupLightboxes(_ref6) {
  let {
    container,
    selector
  } = _ref6;
  if (!container) {
    throw new Error("Lightboxes require a container to be passed in");
  }
  this.selector = selector;
  const hasLightboxes = container.querySelector(selector);
  if (!hasLightboxes) {
    return;
  }
  const handlerOptions = {
    capture: true
  };
  container.addEventListener("click", event => {
    this.handleClickEvent(event, selector);
  }, handlerOptions);
  this.lightboxClickElements.push({
    container,
    handlerOptions
  });
}
async function _cleanupLightboxes() {
  this.closeLightbox();
  this.lightboxClickElements.forEach(_ref7 => {
    let {
      container,
      handlerOptions
    } = _ref7;
    container.removeEventListener("click", this.handleClickEvent, handlerOptions);
  });
  this.lightboxClickElements = [];
}
async function _setupDocumentFocus() {
  if (!this.lightboxIsOpen) {
    return;
  }
  this.lastFocusedElement = document.activeElement;
  document.activeElement.blur();
  document.querySelector(SELECTORS.CLOSE_BUTTON)?.focus();
  const focusableElements = document.querySelectorAll(SELECTORS.LIGHTBOX_CONTAINER + " button");
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];
  const focusTraps = document.querySelectorAll(SELECTORS.FOCUS_TRAP);
  const firstfocusTrap = focusTraps[0];
  const lastfocusTrap = focusTraps[focusTraps.length - 1];
  this.onFocus = _ref8 => {
    let {
      target
    } = _ref8;
    if (target === firstfocusTrap) {
      lastFocusableElement.focus();
    } else if (target === lastfocusTrap) {
      firstFocusableElement.focus();
    }
  };
  document.addEventListener("focus", this.onFocus, {
    passive: true,
    capture: true
  });
}
async function _restoreDocumentFocus() {
  document.removeEventListener("focus", this.onFocus, {
    passive: true,
    capture: true
  });
  document.activeElement.blur();
  this.lastFocusedElement?.focus();
}
async function _reset() {
  this.appEvents.off(LIGHTBOX_APP_EVENT_NAMES.CLEAN, this, this.cleanupLightboxes);
}
export { LightboxService as default };